import {NgModule} from '@angular/core';
import {FINISHINGS} from '@infrastructure/http/finishing/finishings';
import {HttpFinishingsService} from '@infrastructure/http/finishing/http-finishings.service';
import {HttpProductionSchedulesService} from '@infrastructure/http/production-schedule/http-production-schedules.service';
import {PRODUCTION_SCHEDULES} from '@infrastructure/http/production-schedule/production-schedules';
import {SharedModule} from '@shared/shared.module';
import {AgGridModule} from 'ag-grid-angular';
import {PathLengthComponent} from './add/plan/builder-summary/path-length/path-length.component';
import {PathWidthComponent} from './add/plan/builder-summary/path-width/path-width.component';
import {ProductionScheduleBuilderSummaryComponent} from './add/plan/builder-summary/production-schedule-builder-summary.component';
import {ConfirmProductionScheduleDesktopComponent} from './confirm/confirm-desktop/confirm-production-schedule-desktop.component';
import {WarningsForProductionSchedulePlanComponent} from './confirm/confirm-desktop/warnings-for-production-schedule-plan/warnings-for-production-schedule-plan.component';
import {ConfirmProductionScheduleOnDesktopCommand} from './confirm/confirm-production-schedule-on-desktop-command';
import {ConflictsWithOrderLinesAmountComponent} from './confirm/conflicts-with-order-lines/amount/conflicts-with-order-lines-amount.component';
import {ConflictsWithOrderLinesComponent} from './confirm/conflicts-with-order-lines/conflicts-with-order-lines.component';

@NgModule({
  providers: [ConfirmProductionScheduleOnDesktopCommand, {provide: PRODUCTION_SCHEDULES, useClass: HttpProductionSchedulesService}, {provide: FINISHINGS, useClass: HttpFinishingsService}],
  imports: [AgGridModule, SharedModule],
  declarations: [
    ConfirmProductionScheduleDesktopComponent,
    WarningsForProductionSchedulePlanComponent,
    ConflictsWithOrderLinesAmountComponent,
    ConflictsWithOrderLinesComponent,
    ProductionScheduleBuilderSummaryComponent,
    PathWidthComponent,
    PathLengthComponent
  ],
  exports: [ConflictsWithOrderLinesComponent, ProductionScheduleBuilderSummaryComponent]
})
export class ProductionScheduleSharedModule {}
